import axiosInstance from '../axiosInterceptor/axiosInstance'

const getGroupTeams = async (orgId, groupId) => {
  const url = `v1/orgs/${orgId}/season-teams`
  const response = await axiosInstance.get(url, { params: { groupId } })
  return response?.data
}

export default getGroupTeams
